import React from "react";
import { Box, Button, TextField } from "@mui/material";

const OrderSearchHeading = ({ setIsDrawerOpen }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      flexDirection={{ xs: "column", sm: "row" }}
      gap={2}
    >
      <TextField
        disabled
        type="search"
        placeholder="Search invoices"
        sx={{ width: { xs: "100%", sm: "40%" } }}
        variant="outlined"
      />
      <Button
        onClick={() => setIsDrawerOpen(true)}
        variant="contained"
        sx={{
          width: { xs: "100%", sm: "200px" },
          backgroundColor: "primary.main",
          color: "white",
        }}
      >
        Create new Order
      </Button>
    </Box>
  );
};

export default OrderSearchHeading;
